//处理用户授权,登录
import Camp from '@/models/camp'
import { saveOpenid } from '@/utils/cookie'
import WeChatConfig from '@/config/wechat'
import Env from '@/config/env'
import AuthModel from '@/models/auth'
import UserModel from '@/models/user'
import { mapState, mapActions } from 'vuex'
import register from '@/components/register/register'
import { CodeValidTime, HandleValidTime, DeleteCode } from '@/utils/tools'
import { isWeiXin, isApp } from './../utils/utils'
export const auth = {
  components: {
    register
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      token: state => state.user.token
    })
  },
  created() {
    if (isWeiXin()) {
      this.mixinFirstComeIn()
    } else if (isApp() || window.location.pathname.indexOf('agreement')) {
      this.mixinAuthShow = false
    } else if (!this.token) {
      this.mixinAuthShow = true
    }
  },
  data() {
    return {
      mixinAuthShow: false //注册弹窗
    }
  },
  methods: {
    //处理注册的时候，code超时，重新注册
    async mixinOverTimeRegister(data) {
      //如果session有储存上次失效的信息，就将这些信息发送给接口注册
      data.code = this.$route.query.code
      const res = await AuthModel.register(data)
      if (res.status === 200) {
        if (this.$route.query.code) {
          this.setToken(res.data.token)
          saveOpenid(res.data.openId)
        } else {
          this.setToken(res.data)
        }
        const UserInfo = await UserModel.getUserInfo()
        if (UserInfo.status === 200) {
          this.setUserInfo(UserInfo.data)
        }
        this.$toast.clear() //清除'登录中'toast
        sessionStorage.removeItem('registerInfo') //不管注册成不成功，都删除session的registerInfo
      } else {
        this.$toast.clear() //清除'登录中'toast
        sessionStorage.removeItem('registerInfo') //不管注册成不成功，都删除session的registerInfo
      }
    },
    //一进来判断是否有code
    mixinFirstComeIn() {
      //路由携带code参数就开启弹框
      if (this.$route.query.code) {
        this.handleCodeVaild(true)
      }
    },
    //处理微信code是否在18分钟时限内
    handleCodeVaild(isCreated) {
      let time1 = JSON.parse(sessionStorage.getItem('codeTimeStamp'))
      let time2 = new Date().getTime()
      if (HandleValidTime(time1, time2)) {
        //微信code在有效时限内
        if (isCreated) {
          //如果是created周期是将code发给接口验证
          if (!this.token) {
            //如果没有token，才发送请求
            this.checkToken()
          }
        } else {
          //否则就弹出注册框
          this.mixinAuthShow = true
        }
      } else {
        //微信code不在有效时限内，就重新授权
        this.handleCodeOverTime()
      }
    },
    //处理用户,(没有token的情况下，有code就调用'检查code函数'，没有code就调用'重新授权函数')
    //页面使用这个mixin方法
    handleMixinAuth() {
      if (!this.token && this.utils.isWeiXin()) {
        if (!this.$route.query.code) {
          this.handleWxAuthority()
        } else {
          this.handleCodeVaild()
        }
      } else if (!this.token && !this.utils.isWeiXin()) {
        //如果不是微信环境，普通的浏览器 也弹框注册框
        this.mixinAuthShow = true
      }
    },
    async checkToken() {
      if (this.$route.query.code) {
        //从服务器请求token
        const res = await AuthModel.requestTokenFromServe(
          this.$route.query.code
        ) //登录
        if (res.status == 200) {
          if (res.data.openId) {
            saveOpenid(res.data.openId)
          }
          if (res.data.token) {
            //能换回token
            this.setToken(res.data.token)
            const UserInfo = await UserModel.getUserInfo()
            this.seminarVip()
            if (UserInfo.status === 200) {
              this.setUserInfo(UserInfo.data)
            }
          } else {
            let data = JSON.parse(sessionStorage.getItem('registerInfo'))
            if (data) {
              this.$toast.loading({
                message: '登录中...',
                forbidClick: true,
                duration: 0
              })
              //如果session有储存上次失效的信息，就自动重新注册
              this.mixinOverTimeRegister(data)
            } else {
              //如果session没有储存上次失效的信息,就弹框注册
              this.mixinAuthShow = true
            }
          }
        } else {
          let redirectUrl = this.$route.query.redirectUrl
          if (res.data === '') {
            this.$router.replace({
              path: '/register',
              query: {
                code: `${this.wechatCode}`,
                redirectUrl
              }
            })
            return
          }
        }
      }
    },
    //判断是否vip
    async seminarVip() {
      const res = await Camp.seminarVip()
      if (res.status == 200) {
        const isVip = res.data
        this.setGlobalVip(isVip)
      }
    },
    //处理微信code超时，弹框提示,重新去授权
    handleCodeOverTime() {
      this.$dialog
        .alert({
          title: '提示',
          message: '您的微信授权已超时，需重新授权',
          confirmButtonText: '去授权'
        })
        .then(() => {
          this.handleWxAuthority()
        })
    },
    //根据是否正式环境，处理不同环境下微信授权
    handleWxAuthority() {
      if (Env.mobileUrlList.indexOf(window.location.hostname) !== -1) {
        // 在正式环境情况下：
        let href =
          Env.mobileUrlFormal +
          window.location.pathname +
          window.location.search
        //如果重定向有code就去掉code
        href = DeleteCode(href)
        const appid = WeChatConfig.appid
        let redirect_url = encodeURIComponent(href)
        var url =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
          appid +
          '&redirect_uri=' +
          redirect_url +
          '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        CodeValidTime()
        location.replace(url)
      } else {
        //不在正式环境情况下：
        const appid = WeChatConfig.appid
        const WeChatUrl = WeChatConfig.url
        const myUrl = window.location.origin
        let url = myUrl + window.location.pathname + window.location.search
        //如果重定向有code就去掉code
        url = DeleteCode(url)
        const href =
          WeChatUrl + '?url=' + encodeURIComponent(url) + '&appid=' + appid
        CodeValidTime()
        location.replace(href)
      }
    },
    ...mapActions(['setUserInfo', 'setToken', 'setGlobalVip'])
  }
}
